import { patchRequest } from "../httpMethods";

export const patchTrainerChangeResponse = (payload) =>
    patchRequest(`trainerUp/response`, payload);